<template>
	<div class="firewood_prod__container" :class="{'firewood_prod--resp_active': responsive_modal}">
		<span class="woo_btn" @click="triggerResponsiveModal()">Buy Now</span>

		<div class="free_delivery_prod free_delivery_prod--yellow free_delivery_prod--tablet">
			<p class="free_delivery_prod__heading">FREE delivery Nationwide on all firewood orders</p>
			<p class="free_delivery_prod__subtitle"><span>Classic Dumpy and Barrow Bags available for local delivery only</span> <a href="#" class="free_delivery_prod__link">Learn More</a></p>
		</div>

		<p class="out_of_stock" v-if="!selected.stock">Out of stock</p>

		<div class="firewood_prod">

			<div class="firewood_prod__step">
				<p class="firewood_prod__discount" v-if="discountNote">{{ discountNote }}</p>
				<p class="firewood_prod__heading"><span class="firewood_prod__heading--orange" v-if="cross_sells.length > 0">Step 1. </span>Quantity</p>

				<quantity v-model="selected.qty" :min='1'></quantity>
			</div>

			<div class="firewood_prod__step" v-if="cross_sells.length > 0">
				<p class="firewood_prod__heading"><span class="firewood_prod__heading--orange">Step 2.</span> We recommend<span class="firewood_prod__heading--resi_hide"> the following</span></p>

				<div class="firewood_prod__items">

					<div class="firewood_prod__item" v-for="product in cross_sells" :key="product.id">
						<figure class="firewood_prod__img">
							<img :src="product.img" alt="">
						</figure>

						<p class="firewood_prod__title">{{ product.name }}</p>

						<p v-if="product.sale && !user.retail" class="firewood_prod__price firewood_prod__price--small">
							<del>£{{ product.price }}</del> £{{ product.sale }}
						</p>
						<p v-else-if="user.retail && product.wholesale_price" class="firewood_prod__price firewood_prod__price--small">
							<del>£{{ product.price }}</del> £{{ product.wholesale_price }}
						</p>
						<p v-else class="firewood_prod__price firewood_prod__price--small">£{{ product.price }}</p>

						<div class="firewood_prod__control" :class="product.qty > 0 ? 'firewood_prod__control--added' : ''">
							<span class="firewood_prod__add" @click="addCrossSell(product)">Add</span>

							<quantity v-model="product.qty"></quantity>
						</div>
					</div>

				</div>
			</div>

			<div class="firewood_prod__add_to_basket">
				<div class="firewood_prod__btn_wrap" :class="{'firewood_prod__btn_wrap--loading': loading}">
					<button class="firewood_prod__btn" type="button" @click="addToBasket()">Add to basket</button>

					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="35" height="35" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(50,50)"><g transform="scale(0.7)"><circle cx="0" cy="0" r="50" fill="#e75000"></circle><circle cx="0" cy="-19" r="15" fill="#ffffff"><animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 0 0;360 0 0"></animateTransform></circle></g></g></svg>
				</div>

				<div class="firewood_prod__total">
					<span class="firewood_prod__total--price">£{{ getTotal }}</span>
					<!-- <span class="firewood_prod__title" v-if="extras > 0">+ £{{ extras }} extras</span> -->
				</div>
			</div>

			<div class="free_delivery_prod free_delivery_prod--yellow free_delivery_prod--mobile">
				<p class="free_delivery_prod__heading">FREE delivery Nationwide on all firewood orders</p>
				<p class="free_delivery_prod__subtitle"><span>Classic Dumpy and Barrow Bags available for local delivery only</span> <a href="#" class="free_delivery_prod__link">Learn More</a></p>
			</div>

			<figure class="firewood_prod__close" @click="responsive_modal = false"></figure>
		</div>
		<figure class="firewood_prod__closestrip" @click="responsive_modal = false"></figure>

		<!-- <modal v-bind:modal.sync="modal"></modal> -->
	</div>

</template>

<script>
	import Qty from './quantity.vue';
	// import Modal from './product-modal.vue';
	const axios = require('axios');

	export default {
		components: {
			'quantity': Qty,
			// 'modal': Modal,
		},
		data: function() {
			return {
				product_name: '',
				product_id: '',
				variations: {},
				cross_sells: {},
				user: {},
				selected: {
					price: 0,
					qty: 1,
					stock: true
				},
				modal: {
					active: false,
					message: '',
					urls: {}
				},
				loading: false,
				responsive_modal: false,
				discountNote: ''
			}
		},
		watch: {

		},
		computed: {
			extras() {
				var subtotal = 0;
				for (var i = 0; i < this.cross_sells.length; i++) {
					if (this.cross_sells[i].price) {
						var price = this.cross_sells[i].price;

						if (this.cross_sells[i].sale) {
							price = this.cross_sells[i].sale;
						}

						if (this.user.retail && this.cross_sells[i].wholesale_price) {
							price = this.cross_sells[i].wholesale_price;
						}

						subtotal += parseInt(this.cross_sells[i].qty) * parseFloat(price);
					}
				}
				return this.addZeroes(subtotal.toFixed(2));
			},
			getTotal() {
				var total = (this.selected.price * this.selected.qty) + parseInt(this.extras);
				return this.addZeroes(total.toFixed(2));
			},
			qtyExtras() {
				var count = 0;
				for (var i = 0; i < this.cross_sells.length; i++) {
					if (this.cross_sells[i].qty > 0) {
						count += this.cross_sells[i].qty;
					}
				}
				return count;
			},
		},
		created() {
			this.product_name = pf_obj.product.name;
			this.product_id = pf_obj.product.id;
			this.modal.urls = pf_obj.urls;
			this.user = pf_obj.user;

			if (!pf_obj.stock) {
				this.selected.stock = false;
			}

			if (this.user.retail && pf_obj.product.wholesale_price) {
				this.selected.price = pf_obj.product.wholesale_price;
			} else {
				this.selected.price = pf_obj.product.price;
			}

			for (var i = 0; i < pf_obj.cross_sells.length; i++) {
				pf_obj.cross_sells[i].qty = 0;
			}
			this.cross_sells = pf_obj.cross_sells;
			this.discountNote = pf_obj.discount_note || '';
		},
		methods: {
			getPrice() {
				return this.display_regular_price;
			},
			getActualPrice() {
				return this.display_price;
			},
			getSalePrice() {
				if (this.display_price !== this.display_regular_price) {
					return this.display_price;
				} else {
					return false;
				}
			},
			addCrossSell(product) {
				product.qty++;
			},
			addToBasket() {
				// Start loading effect
				this.loading = true;

				// Reset modalText
				this.modal.message = '';
				this.modal.errors = {};

				// Set modal message text
				this.modal.message = this.modalText();

				var data = {
					product_id: this.product_id,
					qty: this.selected.qty,
					cross_sells: this.cross_sells
				};

				const params = new URLSearchParams();
				params.append('action', 'aj_ajax_add_to_basket');
				params.append('data', JSON.stringify(data));

				axios.post(WPURLS.ajaxurl, params)
					.then((response) => {
						if (response.data.result.error !== undefined && response.data.result.error.length > 0) {
							this.modal.errors = response.data.result.error;
							this.adjustModalMessage();
						}

						// Trigger modal
						// this.modal.active = true;
						this.showAddBasketMessage();

					})
					.catch((error) => {
						// handle error
						console.log(error);
					})
					.then(() => {
						this.loading = false;
						jQuery( document.body ).trigger( 'wc_fragment_refresh' );
					});

			},
			modalText(overrideExtras = null) {
				var text = '<strong>' + this.product_name + '</strong>';
				var extras_qty = this.qtyExtras;

				if (overrideExtras !== null) {
					extras_qty = overrideExtras;
				}

				if (extras_qty > 0) {
					text += ' and ' + extras_qty + ' extra';

					if (extras_qty > 1) {
						text += 's';
					}
				}

				if (extras_qty <= 1) {
					text += ' has';
				}

				if (extras_qty > 1) {
					text += ' have';
				}

				text += ' been added to your basket.';
				return text;
			},
			adjustModalMessage() {
				var main = 0;
				var extra = 0;

				for (var i = 0; i < this.modal.errors.length; i++) {
					var check_product = this.modal.errors[i].notice.search(this.product_name);

					if (check_product < 0) {
						// The main product was added

						for (var a = 0; a < this.cross_sells.length; a++) {
							var check_extras = this.modal.errors[i].notice.search(this.cross_sells[a].name);
							if (check_extras >= 0) {
								extra += this.cross_sells[a].qty;
							}
						}

					} else {
						// The main product was added
						main++;
					}
				}

				if (main > 0) {
					// this.modal.message = this.product_name + ' is currently out of stock.';
					this.modal.message = 'Something went wrong';
				}

				if (extra > 0 && main == 0) {
					var override = this.qtyExtras - extra;
					this.modal.message = this.modalText(override);
				}
			},
			triggerResponsiveModal() {
				this.responsive_modal = true;
				jQuery('.firewood_prod').css('top', window.pageYOffset);
			},
			showAddBasketMessage() {
				var error_html = '<ul class="woocommerce-error" role="alert">';

				if (this.modal.errors.length > 0) {
					for (var i = 0; i < this.modal.errors.length; i++) {
						error_html += '<li>' + this.modal.errors[i].notice + '</li>';
					}

					error_html += '</ul>';
				}

				this.$nextTick(() => {
					jQuery('.woocommerce-notices-wrapper').empty();
					jQuery('.woocommerce-notices-wrapper').append('<div class="woocommerce-message" role="alert">' + this.modal.message + ' <a href="' + this.modal.urls.basket + '">View your basket</a></div>');
					if (this.modal.errors.length > 0) {
						jQuery('.woocommerce-notices-wrapper').append(error_html);
					}
					jQuery('html, body').animate({
		  	        scrollTop: 0
		  	    	}, 200);

					this.responsive_modal = false;
				});
			},
			addZeroes(num) {
			  const dec = num.split('.')[1]
			  const len = dec && dec.length > 2 ? dec.length : 2
			  return Number(num).toFixed(len)
			}
		}
	}
</script>
